import React, { useState } from "react";
import { useNavigate } from "react-router";
import { useDiary } from "@/context/DiaryContext";
import EmotionCard from "@/components/dataDisplay/cards/EmotionCard";
import { EMOTIONS } from "@/constants/emotions";
import styles from "./styles";

export default function DailyEmotion() {
  const navigate = useNavigate();
  const { diaryData, updateDiaryData } = useDiary();
  const [selectedEmotion, setSelectedEmotion] = useState<string>(
    diaryData.feeling || EMOTIONS[0].id
  );
  const handleBack = () => {
    navigate("/records/daily-intro");
  };

  const handleNext = () => {
    updateDiaryData({ feeling: selectedEmotion });
    navigate("/records/daily-reason");
  };

  return (
    <div style={styles.container}>
      <div style={styles.scrollContainer}>
        <h1 style={styles.title}>¿Cómo te sientes hoy?</h1>
        <div
          style={styles.emotionsContainer}
        >
          {EMOTIONS.map((emotion) => {
            const isSelected = emotion.id === selectedEmotion;
            return (
              <EmotionCard
                key={emotion.id}
                emotion={emotion}
                isSelected={isSelected}
                setSelectedEmotion={setSelectedEmotion}
              />
            );
          })}
        </div>
      </div>

      <div style={styles.buttonsContainer}>
        <button onClick={handleBack} style={styles.backButton}>
          <span style={styles.backButtonText}>Atrás</span>
        </button>
        <button
          onClick={handleNext}
          disabled={!selectedEmotion}
          style={styles.nextButton}
        >
          <span style={styles.backButtonText}>Siguiente</span>
        </button>
      </div>
    </div>
  );
}
